import { render, staticRenderFns } from "./BidLotMessage.vue?vue&type=template&id=ec96affe&scoped=true&"
import script from "./BidLotMessage.vue?vue&type=script&lang=js&"
export * from "./BidLotMessage.vue?vue&type=script&lang=js&"
import style0 from "./BidLotMessage.vue?vue&type=style&index=0&id=ec96affe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec96affe",
  null
  
)

export default component.exports